import React from 'react';

interface SlidePanelProps {
  tag?: 'li' | 'div';
  isActive: boolean;
  children: React.ReactNode;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

const SlidePanel: React.FC<SlidePanelProps> = ({
  tag,
  isActive,
  children,
  onMouseEnter,
  onMouseLeave,
}) => {
  const Tag = tag as keyof JSX.IntrinsicElements;
  return (
    <Tag
      className={`liteSlider__panel ${isActive ? 'active' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Tag>
  );
};

export default SlidePanel;
